// Auto-generated by scripts/sync-version.js from package.json. Do not edit by hand.
export const APP_VERSION = "1.7.1";
